import React from 'react';
import { connect } from 'react-redux';

import * as billingSelectors from '../../../../redux/auth/billing/selectors';

import { selectCurrentPeriodEnd, selectPrice, selectDuration } from './selectors';
import SubscriptionCard from './SubscriptionCard';

const SubscriptionCardConnected = (props) => <SubscriptionCard {...props} />;

const mapStateToProps = (state) => ({
  error: billingSelectors.selectError(state),
  errorMessage: billingSelectors.selectErrorMessage(state),
  isCanceled: billingSelectors.selectSubscriptionIsCanceled(state),
  isLoading: billingSelectors.selectIsLoading(state),

  currentPeriodEnd: selectCurrentPeriodEnd(state),
  price: selectPrice(state),
  duration: selectDuration(state),
});

export default connect(mapStateToProps)(SubscriptionCardConnected);
